import { useState } from "react";
import { Player } from 'media-stream-player';
import "./ClawCameraFeeds.scss";

const SingleMachineCameraFeed = ({ machineID, machineName }) => {
    const [viewType, setViewType] = useState('front'); // 'front' or 'top'
    const [switchingFeed, setSwitchingFeed] = useState(false);

    // Define camera feeds for this machine
    const cameraFeeds = {
        1: {
            front: 'clawcam1.twitchcampaignstudio.com',
            top: 'clawcam2.twitchcampaignstudio.com'
        },
        2: {
            front: 'clawcam3.twitchcampaignstudio.com',
            top: 'clawcam4.twitchcampaignstudio.com'
        }
    };

    const currentFeed = cameraFeeds[machineID]?.[viewType];

    const toggleView = () => {
        setSwitchingFeed(true);
        setViewType(prevView => prevView === 'front' ? 'top' : 'front');
        setTimeout(() => {
            setSwitchingFeed(false);
        }, 100);
    };

    return (
        <div className="fl-column">
            <div className="fl-row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 style={{ margin: 0 }}>{machineName} Camera</h4>
                <div className="fl-row compact">
                    <button 
                        className={`standard-button ${viewType === 'front' ? '' : 'button-inactive'}`}
                        onClick={() => {
                            if (viewType !== 'front') toggleView();
                        }}
                        style={{ 
                            margin: 0, 
                            height: '2.5rem', 
                            padding: '0.5rem 1rem',
                            fontSize: '0.9rem'
                        }}
                    >
                        Front View
                    </button>
                    <button 
                        className={`standard-button ${viewType === 'top' ? '' : 'button-inactive'}`}
                        onClick={() => {
                            if (viewType !== 'top') toggleView();
                        }}
                        style={{ 
                            margin: 0, 
                            height: '2.5rem', 
                            padding: '0.5rem 1rem',
                            fontSize: '0.9rem'
                        }}
                    >
                        Top View
                    </button>
                </div>
            </div>
            <div className="claw-feed-holder">
                {!switchingFeed && currentFeed && (
                    <Player
                        hostname={currentFeed}
                        initialFormat="RTP_H264"
                        secure
                        autoPlay
                        autoRetry
                    />
                )}
            </div>
        </div>
    );
};

export default SingleMachineCameraFeed;
